<template>
	<popup v-model="visable" okText="确定" showClose="true" @confirm="visable=false" @close="close">
		<div class="details">
			<p class="time">{{info.motionTime}}</p>
			<p class="unit flex between"><span>已跑公里</span><span>（公里）</span></p>
			<span class="num flex center">{{info.km}}</span>
			<div class="count flex between">
				<div class="flex start-v">
					<span>{{duration}}</span>
					<span>跑步时长</span>
				</div>
				<div class="flex start-v">
					<span>{{info.paceAvg}}</span>
					<span>平均配速</span>
				</div>
				<div class="flex start-v">
					<span>{{info.calorie}}</span>
					<span>消耗卡路里</span>
				</div>
			</div>
		</div>
	</popup>
</template>

<script>
import {secondsToString} from "@/utils/date.js";
export default {
	data() {
		return {
			visable: false,
			info:{}
		};
	},
	computed:{
		duration(){
			return secondsToString(this.info.duration)
		}
	},
	methods:{
		show(info){
			this.info = info;
			this.visable = true;
		},
		close(){
			this.visable = false;
		}
	}
};
</script>

<style scoped lang="less">
.details {
	padding: 35/@rem 21/@rem 22/@rem;
	p.time{
		font-size: 10/@rem;
		color: rgba(31, 30, 29, 0.3);
	}
	p.unit{
		font-size: 14/@rem;
		padding-top: 14/@rem;
	}
	span.num{
		padding: 16/@rem 0;
		font-size: 42/@rem;
		font-weight: bold;
		color: rgba(255, 162, 22, 1);
	}

	.count{
		padding: 19/@rem 12/@rem 15/@rem;
		background-color: rgba(255, 246, 233, 1);
		border-radius: 12/@rem;
		>div{
			span:first-child{
				font-size: 16/@rem;
				font-weight: bold;
			}
			span:last-child{
				padding-top: 4/@rem;
				color: rgba(31, 30, 29, 0.3);
				font-size: 10/@rem;
			}
		}
	}
}
</style>
